import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import axios from "axios/index";
import payform from 'payform';
import moment from 'moment-timezone';
import Swal from "sweetalert2";
import aes256 from 'aes256';
import {withTranslation} from 'react-i18next';
import i18n from "i18next";


class card_checkout extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            open: false,
            windowHeight: 0,
            nca: 0,
            ncaAmtFlag: false,
            ncaAmtName: '',
            tax: [],
            totalLoyaltyPoints: 0,
            cardList: [],
            showCards: false,
            categoryList: [],
            guestFlag: false,
            finalTax: 0,
            swalButton: '',
            details: '',
            storeOrderType: '',
            storeDeliveryFee: 0,
            ncaMarkup: "N",
            ncaOnTipEnabled: "Y",
            finalNca: 0,
            couponApplied: "N",
            couponType: "",
            couponDiscount: 0,
            couponID: 0,
            cardDate: '',
            storeDisclaimer: '',
            deliveryDisclaimer: '',
            curbsideDisclaimer: '',
            dineinDisclaimer: '',
            key: 'x!A%D*G-KaPdSgVkYp3s5v8y/B?E(H+M'
        };
    };

    onOpenModal = (details) => {
        if (details != "") {
            this.setState({details: details});
        }
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    handleChange = e => {

        this.setState({cardDate: this.normalizeInput($(e.target).val(), this.state.cardDate)});
    };

    normalizeInput = (value, previousValue) => {
        if (!value) return value;
        var currentValue = value.replace(/[^\d]/g, '');
        var cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 2) return currentValue;

            console.log(currentValue.slice(0, 2) + " " + currentValue.slice(2));
            if (cvLength < 4) return `${currentValue.slice(0, 2)}/${currentValue.slice(2)}`;
            return `${currentValue.slice(0, 2)}/${currentValue.slice(2)}`;
        }
    };

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        this.onOpenModal(i18n.t('loading')+"...");
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });


        var url = '';
        var url1 = '';

        var dbconn = new db();
        dbconn.getAllOrder().then(productData => {

            var cartTotal = 0;
            for (var i = 0; i < productData.length; i++) {

                var arrObj = {};
                arrObj['product_id'] = productData[i].product_id;


                if (productData[i].product_discount_type == "") {
                    arrObj['product_price'] = productData[i].product_price;
                } else if (productData[i].product_discount_type == "P" || productData[i].product_discount_type == "H" || productData[i].product_discount_type == "G") {

                    arrObj['product_price'] = (parseFloat(productData[i].product_price) - ((parseFloat(productData[i].product_price) * parseFloat(productData[i].product_discount)) / 100)).toFixed(2);
                } else if (productData[i].product_discount_type == "A") {
                    arrObj['product_price'] = (parseFloat(productData[i].product_price) - parseFloat(productData[i].product_discount)).toFixed(2);
                }
                if (productData[i].product_discount_type == "G") {
                    arrObj['mod_price'] = 0;
                } else {
                    arrObj['mod_price'] = productData[i].mod_price;
                }

                arrObj['product_quantity'] = productData[i].product_quantity;
                arrObj['product_mod'] = productData[i].product_modifiers;
                arrObj['product_original_price'] = productData[i].product_original_price;
                arrObj['product_notes'] = productData[i].product_notes;
                arrObj['product_discount'] = productData[i].product_discount;
                arrObj['product_discount_type'] = productData[i].product_discount_type;
                arrObj['product_loyalty'] = productData[i].product_loyalty_enabled;
                if (productData[i].product_loyalty_enabled == "Y") {
                    arrObj['product_loyalty_spent'] = productData[i].product_loyalty_price;
                } else {
                    arrObj['product_loyalty_spent'] = 0;
                }

                if (productData[i].product_loyalty_enabled == "N") {

                    console.log(arrObj['product_price']+" "+arrObj['mod_price']+" "+arrObj['product_quantity']);

                    cartTotal += (parseFloat(arrObj['product_price']) + parseFloat(arrObj['mod_price'])) * parseInt(arrObj['product_quantity']);


                } else {
                    cartTotal += (arrObj['mod_price'] * parseInt(arrObj['product_quantity']));
                }


            }

            sessionStorage.setItem("cartTotal", cartTotal);


            if (sessionStorage.getItem('guestFlag') == 'Y') {
                url = API_ROOT + '/fetchstorestats?guestFlag=Y&store_id=' + localStorage.getItem('store_id');


                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(storeData => {

                        this.onCloseModal();
                        if (storeData.status == 1) {

                            this.setState({nca: storeData.store_data[0].store_default_nca});
                            this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                            this.setState({ncaAmtName: storeData.store_data[0].store_nca_name});
                            this.setState({ncaMarkup: storeData.store_data[0].store_product_markup_enabled});
                            this.setState({storeOrderType: storeData.store_data[0].store_order_type});
                            this.setState({ncaOnTipEnabled: storeData.store_data[0].store_tip_nca_enabled});
                            this.setState({storeDisclaimer: storeData.store_data[0].store_disclaimer_msg});
                            this.setState({deliveryDisclaimer: storeData.store_data[0].store_delivery_disclaimer});
                            this.setState({curbsideDisclaimer: storeData.store_data[0].store_curbside_disclaimer});
                            this.setState({dineinDisclaimer: storeData.store_data[0].store_dinein_disclaimer});

                            localStorage.setItem("store_curbside_desc", storeData.store_data[0].store_curbside_desc);

                            if (sessionStorage.getItem("orderType") == "D") {
                                this.setState({storeDeliveryFee: sessionStorage.getItem("orderDeliveryFee")});
                            } else {
                                this.setState({storeDeliveryFee: 0});
                            }
                            var taxArray = storeData.store_data[0].store_taxes;

                            var totalTax = 0;

                            for (var i = 0; i < taxArray.length; i++) {

                                var tax = ((parseFloat(sessionStorage.getItem('cartTotal')) * parseFloat(taxArray[i].tax_percentage)) / 100);


                                taxArray[i].tax_value = tax.toFixed(2);

                                totalTax += parseFloat(tax.toFixed(2));
                            }

                            this.setState({tax: taxArray});
                            this.setState({finalTax: totalTax.toFixed(2)});
                            this.setState({guestFlag: true});

                        }
                    });
            } else {
                var dbconn = new db();

                dbconn.getAll().then(data => {
                    if (!data || data.length < 1) {
                        this.setState({nosessionredirect: true});
                    } else {

                        var customer_id = data[0].customer_id;
                        var customer_token = data[0].customer_token;
                        url = API_ROOT + '/fetchstorestats?customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');
                        url1 = API_ROOT + '/fetchsavedcards?customer_id=' + customer_id + '&customer_token=' + customer_token;


                        fetch(url1)
                            .then(response => {
                                return response.json();
                            })
                            .then(data => {


                                if (data.status == 1) {

                                    this.setState({cardList: data.card_data});
                                }
                            });

                        fetch(url)
                            .then(response => {
                                return response.json();
                            })
                            .then(storeData => {

                                this.onCloseModal();
                                if (storeData.status == 1) {

                                    this.setState({nca: storeData.store_data[0].store_default_nca});
                                    this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                                    this.setState({ncaMarkup: storeData.store_data[0].store_product_markup_enabled});
                                    var taxArray = storeData.store_data[0].store_taxes;
                                    this.setState({ncaAmtName: storeData.store_data[0].store_nca_name});
                                    this.setState({storeOrderType: storeData.store_data[0].store_order_type});
                                    this.setState({ncaOnTipEnabled: storeData.store_data[0].store_tip_nca_enabled});
                                    localStorage.setItem("store_curbside_desc", storeData.store_data[0].store_curbside_desc);
                                    this.setState({storeDisclaimer: storeData.store_data[0].store_disclaimer_msg});

                                    this.setState({deliveryDisclaimer: storeData.store_data[0].store_delivery_disclaimer});
                                    this.setState({curbsideDisclaimer: storeData.store_data[0].store_curbside_disclaimer});
                                    this.setState({dineinDisclaimer: storeData.store_data[0].store_dinein_disclaimer});


                                    if (sessionStorage.getItem("orderType") == "D") {
                                        this.setState({storeDeliveryFee: sessionStorage.getItem("orderDeliveryFee")});
                                    } else {
                                        this.setState({storeDeliveryFee: 0});
                                    }
                                    var totalTax = 0;

                                    for (var i = 0; i < taxArray.length; i++) {

                                        var tax = ((parseFloat(sessionStorage.getItem('cartTotal')) * parseFloat(taxArray[i].tax_percentage)) / 100);


                                        taxArray[i].tax_value = tax.toFixed(2);

                                        totalTax += parseFloat(tax.toFixed(2));
                                    }

                                    this.setState({tax: taxArray});
                                    this.setState({finalTax: totalTax.toFixed(2)});
                                }
                            });


                    }
                });
            }
        });
    }

    componentDidMount() {

        document.title = "Checkout - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var couponApplied = sessionStorage.getItem("couponApplied");


        if (couponApplied) {


            var type = sessionStorage.getItem("couponType");


            var coupon = sessionStorage.getItem("couponID");

            this.setState({couponID: coupon});
            this.setState({couponApplied: "Y"});
            this.setState({couponType: type});


            if (type == "A" || type == "I") {
                this.setState({couponDiscount: parseFloat(sessionStorage.getItem("couponDiscount"))});

            }
            if (type == "B" || type == "F") {
                var discount = parseFloat(sessionStorage.getItem("couponDiscount"));
                discount = (parseFloat(this.state.cartTotal) * discount) / 100;
                this.setState({couponDiscount: discount});
            }


        }

        var height = $(window).height();

        this.setState({windowHeight: height});

        var cardField = document.getElementById('cardNo');
        payform.cardNumberInput(cardField);


        $('#showCardsBtn').val(i18n.t('show_saved_payment_card'));
        $('#cardName').keyup(function () {

            $('.userCards').prop('checked', false);
        });

        $('#disclosure').click(e => {


            this.state.swalButton.fire({
                title: "&nbsp;&nbsp;&nbsp;Online Pricing Disclosure&nbsp;&nbsp;&nbsp;",
                text: "All items for takeout have been marked up 10% from our regular sit-down menu. This helps compensate for website management and labor costs. But please visit us soon - inside - so you can experience our awesome family of friendly & expedient wait staff, appetizers, beverages, entrees, and desserts! Thank you for your order and continued patronage!",
                allowOutsideClick: false
            });

        });

        var dbconn = new db();
        dbconn.getAllOrder().then(productData => {

            var totalLoyalty = 0;
            productData.forEach(function (product) {

                if (product.product_loyalty_enabled == "Y") {
                    totalLoyalty += parseInt(product.product_loyalty_price);
                }
            });

            this.setState({totalLoyaltyPoints: totalLoyalty});


        });


        $('#checkoutBtn').click(e => {

            e.preventDefault();

            if (this.toVerify()) {
                var orderType = sessionStorage.getItem("orderType");




                var diclaimer="";

                if(orderType=="P"){

                    if( this.state.storeDisclaimer != ""){

                        diclaimer=this.state.storeDisclaimer;
                    }

                }else if(orderType=="D"){

                    if( this.state.deliveryDisclaimer != ""){

                        diclaimer=this.state.deliveryDisclaimer;
                    }

                }else if(orderType=="I"){

                    if( this.state.dineinDisclaimer != ""){

                        diclaimer=this.state.dineinDisclaimer;
                    }

                }else if(orderType=="C"){

                    if( this.state.curbsideDisclaimer != ""){

                        diclaimer=this.state.curbsideDisclaimer;
                    }

                }
               // if (orderType == "P" && this.state.storeDisclaimer != "") {


                    this.state.swalButton.fire({
                        title: i18n.t('disclaimer'),
                        text: diclaimer+ " "+i18n.t('continue_question'),
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonText: '  '+i18n.t('yes')+'  ',
                        cancelButtonText: '  '+i18n.t('no')+'  ',
                        customClass: {
                            confirmButton: 'form-control bkg-purple-btn font w-auto m-0',
                            cancelButton: 'form-control bkg-purple-btn font w-auto m-0 cancelButton'
                        },
                    }).then((result) => {
                        if (result.value) {

                            this.checkOut();
                        } else {

                        }
                    });
               /* } else {

                    this.checkOut();
                }*/

            }

        });
    }

    checkOut() {

        var dbconn = new db();
        dbconn.getAllOrder().then(productData => {
            if (productData.length > 0) {
                this.onOpenModal(i18n.t('submitting_order')+"...");


                if (sessionStorage.getItem('guestFlag') == 'Y') {

                    var orderArr = [];

                    var orderOriginalPrice=0;

                    for (var i = 0; i < productData.length; i++) {

                        var arrObj = {};
                        arrObj['product_id'] = productData[i].product_id;
                        arrObj['product_original_price'] = productData[i].product_original_price;
                        if (productData[i].product_discount_type == "") {
                            arrObj['product_price'] = productData[i].product_price;
                        } else if (productData[i].product_discount_type == "P" || productData[i].product_discount_type == "H" || productData[i].product_discount_type == "G") {

                            arrObj['product_price'] = (parseFloat(productData[i].product_price) - ((parseFloat(productData[i].product_price) * parseFloat(productData[i].product_discount)) / 100)).toFixed(2);
                            arrObj['product_original_price'] = (parseFloat(productData[i].product_original_price) - ((parseFloat(productData[i].product_original_price) * parseFloat(productData[i].product_discount)) / 100)).toFixed(2);
                        } else if (productData[i].product_discount_type == "A") {
                            arrObj['product_price'] = (parseFloat(productData[i].product_price) - parseFloat(productData[i].product_discount)).toFixed(2);
                            arrObj['product_original_price'] = (parseFloat(productData[i].product_original_price) - parseFloat(productData[i].product_discount)).toFixed(2);
                        }
                        if (productData[i].product_discount_type == "G") {
                            arrObj['mod_price'] = 0;
                        } else {
                            arrObj['mod_price'] = productData[i].mod_price;
                        }

                        arrObj['product_quantity'] = productData[i].product_quantity;
                        arrObj['product_mod'] = productData[i].product_modifiers;
                        arrObj['product_notes'] = productData[i].product_notes;
                        arrObj['product_discount'] = productData[i].product_discount;
                        arrObj['product_discount_type'] = productData[i].product_discount_type;
                        arrObj['product_loyalty'] = "N";
                        arrObj['product_loyalty_spent'] = 0;

                        orderArr.push(arrObj);

                        console.log("A "+parseFloat(arrObj['product_original_price'])+" "+parseFloat(productData[i].mod_original_price)+" "+parseFloat(arrObj['product_quantity']));
                        orderOriginalPrice=orderOriginalPrice+((parseFloat(arrObj['product_original_price'])+parseFloat(productData[i].mod_original_price))*parseFloat(arrObj['product_quantity']));
                    }


                    var order_data = {"products": orderArr};

                    var cardDate = $('#cardDate').val().split('/');

                    var cardInfo = {
                        cardName: aes256.encrypt(this.state.key, $('#cardName').val()),
                        cardNo: aes256.encrypt(this.state.key, $('#cardNo').val()),
                        cardYear: aes256.encrypt(this.state.key, cardDate[1]),
                        cardMonth: aes256.encrypt(this.state.key, cardDate[0]),
                        cardCvv: aes256.encrypt(this.state.key, $('#cardCvv').val()),
                        cardZip: aes256.encrypt(this.state.key, $('#cardZip').val()),
                        cardType: aes256.encrypt(this.state.key, payform.parseCardType($('#cardNo').val()))
                    };

                    var url;
                    var options;

                    var orderNca = 0;

                    if (this.state.ncaOnTipEnabled == "Y") {
                        orderNca = $('#ncaDiv').html();
                    } else {
                        orderNca = $('#ncaWithoutDiv').html();
                    }


                    url = API_ROOT + '/createorder';

                    dbconn.getAll().then(data => {

                        options = {
                            user_type: 'C',
                            order_number: 1,
                            order_data: JSON.stringify(order_data),
                            order_sum: $('#sumDiv').html(),
                            order_original_price:orderOriginalPrice,
                            order_tax: JSON.stringify(this.state.tax),
                            order_nca: orderNca,
                            table_name: sessionStorage.getItem("table"),
                            order_tip: sessionStorage.getItem("tip"),
                            order_discount: this.state.couponDiscount,
                            order_time_slot: sessionStorage.getItem("slots"),
                            order_date_slot: sessionStorage.getItem("date"),
                            order_total: $('#subTotalDiv').html(),
                            store_order_type: sessionStorage.getItem("orderType"),
                            order_notes: sessionStorage.getItem("curbsideDesc"),
                            order_delivery_fee: sessionStorage.getItem("orderDeliveryFee"),
                            store_language:localStorage.getItem("store_language"),
                            cardInfo: cardInfo,
                            safeId: "",
                            couponID: this.state.couponID,
                            saveCard: ($('#saveCard').prop('checked') == true) ? 'Y' : 'N',
                            guestFlag: 'Y',
                            timezone: moment.tz.guess(),
                            store_id: localStorage.getItem("store_id"),
                            customer_firstname: data[data.length - 1].customer_firstname,
                            customer_lastname: data[data.length - 1].customer_lastname,
                            customer_email: data[data.length - 1].customer_email,
                            customer_phone: data[data.length - 1].customer_phone,
                            customer_address: data[data.length - 1].customer_address,
                            customer_state: data[data.length - 1].customer_state,
                            customer_city: data[data.length - 1].customer_city,
                            customer_zip: data[data.length - 1].customer_zip,
                        };

                        axios.post(url, options, {timeout: 60000}).then(response => {

                            this.onCloseModal();

                            if (response.data.status == 1) {

                                dbconn = new db();

                                dbconn.deleteAllOrder();


                                dbconn.deleteAll();
                                sessionStorage.setItem('cartTotal', 0);

                                sessionStorage.removeItem("couponApplied");
                                sessionStorage.removeItem("couponID");
                                sessionStorage.removeItem("couponCode");
                                sessionStorage.removeItem("couponType");
                                sessionStorage.removeItem("couponMinSubtotal");
                                sessionStorage.removeItem("couponDeliveryType");
                                sessionStorage.removeItem("couponDiscount");
                                sessionStorage.removeItem("couponProductDetails");
                                this.setState({redirect: true});
                            } else {
                                this.state.swalButton.fire({
                                    title: response.data.message,
                                    allowOutsideClick: false
                                });

                            }
                        }).catch(function (error) {

                            alert(error);
                            console.log(error);
                        });
                    });

                } else {
                    dbconn.getAll().then(data => {

                        var customer_id = data[0].customer_id;
                        var customer_token = data[0].customer_token;
                        var orderArr = [];


                        for (var i = 0; i < productData.length; i++) {

                            var arrObj = {};
                            arrObj['product_id'] = productData[i].product_id;
                            arrObj['product_original_price'] = productData[i].product_original_price;

                            if (productData[i].product_discount_type == "") {
                                arrObj['product_price'] = productData[i].product_price;
                            } else if (productData[i].product_discount_type == "P" || productData[i].product_discount_type == "H" || productData[i].product_discount_type == "G") {

                                arrObj['product_price'] = (parseFloat(productData[i].product_price) - ((parseFloat(productData[i].product_price) * parseFloat(productData[i].product_discount)) / 100)).toFixed(2);
                                arrObj['product_original_price'] = (parseFloat(productData[i].product_original_price) - ((parseFloat(productData[i].product_original_price) * parseFloat(productData[i].product_discount)) / 100)).toFixed(2);
                            } else if (productData[i].product_discount_type == "A") {
                                arrObj['product_price'] = (parseFloat(productData[i].product_price) - parseFloat(productData[i].product_discount)).toFixed(2);
                                arrObj['product_original_price'] = (parseFloat(productData[i].product_original_price) - parseFloat(productData[i].product_discount)).toFixed(2);
                            }
                            if (productData[i].product_discount_type == "G") {
                                arrObj['mod_price'] = 0;
                            } else {
                                arrObj['mod_price'] = productData[i].mod_price;
                            }
                            arrObj['product_quantity'] = productData[i].product_quantity;
                            arrObj['product_mod'] = productData[i].product_modifiers;
                            arrObj['product_notes'] = productData[i].product_notes;
                            arrObj['product_discount'] = productData[i].product_discount;
                            arrObj['product_discount_type'] = productData[i].product_discount_type;
                            arrObj['product_loyalty'] = productData[i].product_loyalty_enabled;
                            if (productData[i].product_loyalty_enabled == "Y") {
                                arrObj['product_loyalty_spent'] = productData[i].product_loyalty_price;
                            } else {
                                arrObj['product_loyalty_spent'] = 0;
                            }
                            console.log("A "+parseFloat(arrObj['product_original_price'])+" "+parseFloat(productData[i].mod_original_price)+" "+parseFloat(arrObj['product_quantity']));
                            orderOriginalPrice=orderOriginalPrice+((parseFloat(arrObj['product_original_price'])+parseFloat(productData[i].mod_original_price))*parseFloat(arrObj['product_quantity']));

                            orderArr.push(arrObj);
                        }


                        console.log(orderArr);

                        var order_data = {"products": orderArr};

                        var cardDate = $('#cardDate').val().split('/');

                        var cardInfo = "";
                        var safeId = "";
                        console.log($('.userCards:checked').val());
                        if ($('.userCards:checked').val() === undefined || $('.userCards:checked').val() == "undefined") {
                            cardInfo = {
                                cardName: aes256.encrypt(this.state.key, $('#cardName').val()),
                                cardNo: aes256.encrypt(this.state.key, $('#cardNo').val()),
                                cardYear: aes256.encrypt(this.state.key, cardDate[1]),
                                cardMonth: aes256.encrypt(this.state.key, cardDate[0]),
                                cardCvv: aes256.encrypt(this.state.key, $('#cardCvv').val()),
                                cardZip: aes256.encrypt(this.state.key, $('#cardZip').val()),
                                cardType: aes256.encrypt(this.state.key, payform.parseCardType($('#cardNo').val()))
                            };
                        } else {
                            safeId = $('.userCards:checked').val();
                        }

                        var url;
                        var options;

                        var orderNca = 0;

                        if (this.state.ncaOnTipEnabled == "Y") {
                            orderNca = $('#ncaDiv').html();
                        } else {
                            orderNca = $('#ncaWithoutDiv').html();
                        }

                        url = API_ROOT + '/createorder';

                        options = {
                            customer_id: customer_id,
                            user_type: 'C',
                            customer_token: customer_token,
                            order_number: 1,
                            store_id: localStorage.getItem("store_id"),
                            order_data: JSON.stringify(order_data),
                            order_original_price:orderOriginalPrice,
                            table_name: sessionStorage.getItem("table"),
                            order_sum: $('#sumDiv').html(),
                            order_tip: sessionStorage.getItem("tip"),
                            order_discount: this.state.couponDiscount,
                            order_tax: JSON.stringify(this.state.tax),
                            store_language:localStorage.getItem("store_language"),
                            order_nca: orderNca,
                            couponID: this.state.couponID,
                            order_total: $('#subTotalDiv').html(),
                            order_time_slot: sessionStorage.getItem("slots"),
                            order_date_slot: sessionStorage.getItem("date"),
                            store_order_type: sessionStorage.getItem("orderType"),
                            order_notes: sessionStorage.getItem("curbsideDesc"),
                            order_delivery_fee: sessionStorage.getItem("orderDeliveryFee"),
                            cardInfo: cardInfo,
                            safeId: safeId,
                            timezone: moment.tz.guess(),
                            saveCard: ($('#saveCard').prop('checked') == true) ? 'Y' : 'N',
                            guestFlag: this.state.guestFlag,
                        };

                        axios.post(url, options).then(response => {

                            this.onCloseModal();

                            if (response.data.status == 1) {

                                dbconn = new db();

                                dbconn.deleteAllOrder();
                                sessionStorage.setItem('cartTotal', 0);
                                sessionStorage.removeItem("couponApplied");
                                sessionStorage.removeItem("couponID");
                                sessionStorage.removeItem("couponCode");
                                sessionStorage.removeItem("couponType");
                                sessionStorage.removeItem("couponMinSubtotal");
                                sessionStorage.removeItem("couponDeliveryType");
                                sessionStorage.removeItem("couponDiscount");
                                sessionStorage.removeItem("couponProductDetails");
                                this.setState({redirect: true});
                            } else {

                                this.state.swalButton.fire({
                                    title: response.data.message,
                                    allowOutsideClick: false
                                });
                            }
                        }).catch(function (error) {
                            //this.onCloseModal();
                            alert(error);
                            console.log(error);
                        });


                    });
                }
            }
        });

    }

    toVerify() {
        if ($('.userCards:checked').val() === undefined || $('.userCards:checked').val() == "undefined") {

            var n = $('#cardDate').val().search(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/i);

            if ($('#cardName').val() == '' ||
                $('#cardName').val() == null ||
                $('#cardNo').val() == '' ||
                $('#cardNo').val() == null ||
                $('#cardDate').val() == '' ||
                $('#cardDate').val() == null ||
                $('#cardCvv').val() == '' ||
                $('#cardCvv').val() == null ||
                $('#cardZip').val() == '' ||
                $('#cardZip').val() == null) {


                this.state.swalButton.fire({
                    title: i18n.t('field_validation'),
                    allowOutsideClick: false
                });
                return false;
            } else if (n < 0) {
                this.state.swalButton.fire({
                    title: i18n.t('expiry_validation'),
                    allowOutsideClick: false
                });
                return false;

            }

        }

        return true;

    }

    showCards = () => {
        if (this.state.showCards == false) {
            this.setState({showCards: true});
            $('#showCardsBtn').val(i18n.t('hide_cards'));
        } else {
            this.setState({showCards: false});
            $('.userCards').prop('checked', false);
            $('#showCardsBtn').val(i18n.t('show_cards'));
        }
    };

    selectCard = (cardId) => {

        var selectedCard = this.state.cardList.map((item, index) => {
            if (item.card_id = cardId) {
                return item;
            }
        });


        $('#saveCard').attr('disabled', true);
        $('#saveCard').prop('checked', false);
    };

    cvvcheck = (event) => {

        const {value, maxLength} = event.target;
        const updatedCvv = value.slice(0, maxLength);

        $('#cardCvv').val(updatedCvv);
    };

    zipcodecheck = (event) => {

        const {value, maxLength} = event.target;
        const updatedZip = value.slice(0, maxLength);

        $('#cardZip').val(updatedZip);
    };

    render() {

        const {open} = this.state;
        const {t} = this.props;
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if (this.state.redirect) {
            return (<Redirect to={'/checkout/confirm'}/>);
        }

        var backBtnURL = '';
        if (sessionStorage.getItem('guestFlag') == 'Y') {
            backBtnURL = '/checkout/guest';
        } else {
            backBtnURL = '/order/view';
        }
        var finalTax = 0;
        var finalNca = 0;
        var subTotal = 0;
        var deliveryCharge = 0;
        var finalTip = parseFloat(sessionStorage.getItem('tip'));
        var savedCards = '';
        var ncaVisible = "none";
        var ncaWithoutTip = "none";
        var deliveryVisible = "none";
        var finalDeliveryCharge = parseFloat(sessionStorage.getItem("orderDeliveryFee")).toFixed(2);
        if (parseFloat(this.state.storeDeliveryFee) > 0 && sessionStorage.getItem('orderType') == "D") {

        } else {
            finalDeliveryCharge = 0;
        }


        if (this.state.ncaAmtFlag == 'Y') {
            finalNca = this.state.nca;
            this.setState({ncaOnTipEnabled: "Y"});
        } else {
            if (this.state.ncaMarkup == "N") {
                if (this.state.ncaOnTipEnabled == "Y") {
                    finalNca = ((parseFloat(sessionStorage.getItem('cartTotal')) + parseFloat(finalDeliveryCharge) + finalTip + parseFloat(this.state.finalTax)) * parseFloat(this.state.nca)) / 100;
                } else {
                    finalNca = ((parseFloat(sessionStorage.getItem('cartTotal')) + parseFloat(finalDeliveryCharge) + parseFloat(this.state.finalTax)) * parseFloat(this.state.nca)) / 100;
                }
            }
        }

        if (finalNca > 0) {
            if (this.state.ncaOnTipEnabled == "Y") {

                ncaVisible = "";
            } else {
                ncaWithoutTip = "";
            }
        } else {
            ncaVisible = "none";
            ncaWithoutTip = "none";
        }

        if (parseFloat(this.state.storeDeliveryFee) > 0 && sessionStorage.getItem('orderType') == "D") {
            deliveryVisible = "";
        } else {
            deliveryVisible = "none";

        }


        subTotal = parseFloat(this.state.finalTax) - this.state.couponDiscount + parseFloat(finalDeliveryCharge) + finalTip + parseFloat(finalNca) + parseFloat(sessionStorage.getItem('cartTotal'));

        if (this.state.showCards && this.state.cardList.length > 0) {

            savedCards =
                <div className="p-b-10">

                    <div style={{textAlign: "center"}}>
                        <ul>
                            {this.state.cardList.map((item, index) => {
                                return (
                                    <li key={item.card_id}><input type="radio" id={item.card_id}
                                                                  name="userCards"
                                                                  class="userCards"
                                                                  value={item.card_safe_id} onChange={() => {
                                        this.selectCard(item.card_id)
                                    }}/> <label htmlFor={item.card_id}> {item.card_type} -
                                        Exp. {item.card_month}/{item.card_year} -
                                        {item.card_number}</label>
                                    </li>);
                            })}
                        </ul>
                    </div>
                </div>;
        }

        var saveCard = '';

        saveCard = (this.state.guestFlag) ? '' :
            (<div className="form-group clear">
                <label className="ch_box">{t('save_payment_information')}

                    <input type="checkbox" id="saveCard" tabIndex="6" name="saveCard"/>
                    <span className="checkmark"></span>
                </label>
            </div>);

        return (
            <div className="mainContainer">
                <header className="fixedHeader">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={backBtnURL}></Link>
                        <h2 className="text-center"><strong>{t('checkout')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white checkout h-100 "
                     style={{position: "fixed", width: "100%", height: "100vh", overflowY: "scroll"}}>
                    <div className="simple-box m-b-0 bp-0 p-b-35 bkg-white middleContent"
                         style={{padding: "0px", paddingBottom: "150px"}}>
                        <div className="form-box w-75 div-center form-box-red">
                            <div className="header-title">
                                <h2 className="text-center font-size-20 m-0">{t('payment_information')}</h2>
                            </div>
                            <div className="header-content m-b-10">
                                <img src="/img/payment_method_img.png" alt="Payment Method Image"/>
                            </div>

                            {(sessionStorage.getItem('guestFlag') == 'N') ?

                                <div className="form-group">
                                    <input type="button"
                                           className="form-control bkg-purple-btn font w-160 m-t-5 m-r-10 float_l"
                                           name="showCardsBtn" id="showCardsBtn" onClick={() => {
                                        this.showCards()
                                    }} style={{width: '100%', marginBottom: '10px'}}
                                    />

                                </div>
                                : ""}

                            {savedCards}
                            <div className="form-box">
                                <div className="form-group m-label-none">
                                    <label className="">{t('cardholder')}</label>
                                    <input type="text" className="form-control" name="cardName" tabIndex="1"
                                           id="cardName"
                                           placeholder=""/>
                                </div>
                                <div className="form-group m-label-none">
                                    <label>{t('ccnumber')}</label>
                                    <input type="text" className="form-control" name="cardNo" tabIndex="2"
                                           id="cardNo"
                                           placeholder="" maxLength="20"/>
                                </div>
                                <div className="form-group  three-column m-r-1 m-label-none">
                                    <label>{t('expiry')}</label>
                                    <input name="expiry" className="form-control" id="cardDate"
                                           value={this.state.cardDate || ''}
                                           onChange={this.handleChange} tabIndex="3" name="cardDate"
                                           type="text" placeholder="MM/YY" maxLength="5"/>
                                </div>
                                <div className="form-group three-column m-r-1  m-label-none">
                                    <label>CVV/CVC</label>
                                    <input type="number" className="form-control" name="cardCvv" tabIndex="4"
                                           id="cardCvv"
                                           onChange={this.cvvcheck}  maxLength="4"/>
                                </div>
                                <div className="form-group  three-column float_l m-label-none">
                                    <label>{t('zip_code')}</label>
                                    <input type="number" className="form-control" name="cardZip" tabIndex="5"
                                           id="cardZip"
                                           onChange={this.zipcodecheck}  maxLength="5"/>
                                </div>

                                {saveCard}
                            </div>

                        </div>
                        <div className="bkg_box_black">
                            <div className="total_box">
                                <ul>
                                    <li>
                                        <label>Sub-Total:</label>$<span
                                        id="sumDiv">{parseFloat(sessionStorage.getItem('cartTotal')).toFixed(2)}</span>
                                    </li>

                                    {(this.state.couponDiscount > 0) ?
                                        <li><label>{t('discount')}:</label>
                                            ${this.state.couponDiscount.toFixed(2)}
                                        </li>
                                        : ''
                                    }

                                    {this.state.tax.map((tax, index) => {

                                        return (<li key={tax.tax_id}>

                                            <label>{tax.tax_name} ({tax.tax_percentage}%):</label> ${tax.tax_value}

                                        </li>);
                                    })}

                                    <li style={{display: deliveryVisible}}>
                                        <label>{t('delivery_charge')}: </label>
                                        $<span
                                        id="deliveryDiv">{parseFloat(this.state.storeDeliveryFee).toFixed(2)}</span>

                                    </li>
                                    <li style={{display: ncaWithoutTip}}>
                                        <label>{this.state.ncaAmtName} ({this.state.nca}%): </label>$<span
                                        id="ncaWithoutDiv">{finalNca.toFixed(2)}</span>
                                    </li>

                                    {(finalTip > 0) ?
                                        <li>
                                            <label>{t('tip')}:</label>
                                            ${finalTip.toFixed(2)}
                                        </li>
                                        : ''
                                    }


                                    <li style={{display: ncaVisible}}>
                                        <label>{this.state.ncaAmtName} ({this.state.nca}%): </label>$
                                        <span id="ncaDiv">{finalNca.toFixed(2)}</span>
                                    </li>


                                    <li className="line"></li>
                                    <li className="total_num"><label>Total:</label>$<span
                                        id="subTotalDiv">{subTotal.toFixed(2)}</span></li>

                                    {(this.state.totalLoyaltyPoints > 0) ?
                                        <li>
                                            <label>{t('points_redeemed')}:</label>
                                            {this.state.totalLoyaltyPoints}
                                        </li>
                                        : ''
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="botton-content m-r-0 w-100">
                            <p className="text-left">{t('payment_disclaimer_1')} <a href="#">{t('terms_link')}</a> {t('payment_disclaimer_2')} <Link
                                to={'/policy'}>{t('privacy_policy')}</Link>.
                            </p>
                        </div>
                        <div className="clearfix"></div>
                        <div className="form-group w-60-d">
                            <input type="button" id="checkoutBtn" value={t('checkout')}/>
                        </div>
                    </div>

                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.details}&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>


                <div className="clearfix"></div>
            </div>
        );
    }

}

export default withRouter(withTranslation()(card_checkout));


// WEBPACK FOOTER //
// ./src/view_components/card_checkout.js